import { AppSider } from 'shared/UI/UIKit/Sider';
import { TableFilter } from 'common/TableFilter';
import { RegionsTable } from './Table/RegionsTable';
import { RegionsTableControls } from './Controls/Controls';
import { CreateRegionModal } from './Modals/Create';
import { EditRegionModal } from './Modals/Edit';
import { RemoveRegionModal } from './Modals/Remove';
import { useRegions } from './Regions/use-regions';
import { regionsFilterFields } from './Regions/filter-fields';

export const Regions = () => {
  const { state, methods } = useRegions();

  return (
    <>
      <RegionsTableControls
        createRegion={methods.createRegion}
        columns={state.columns}
        visibleKeys={state.visibleKeys}
        setVisibleKeys={methods.setVisibleKeys}
        showSider={methods.showSider}
        filterCount={state.filterCount}
      />
      <RegionsTable
        loading={state.loading}
        dataSource={state.regions}
        columns={state.filteredColumns}
        tableState={state.tableState}
        onChange={methods.onTableChange}
      />
      <CreateRegionModal
        visible={state.createModalVisible}
        hide={() => methods.setCreateModalVisible(false)}
      />
      <EditRegionModal
        visible={state.editModalVisible}
        hide={() => methods.setEditModalVisible(false)}
      />
      <RemoveRegionModal
        visible={state.removeModalVisible}
        hide={() => methods.setRemoveModalVisible(false)}
        onItemRemove={methods.onItemRemove}
      />
      <AppSider
        title="Фильтры"
        isSiderVisible={state.siderVisible}
        submitBtnText="Применить"
        cancelBtnText="Сбросить всё"
        hideSider={methods.hideSider}
      >
        <TableFilter
          fields={regionsFilterFields}
          submitBtnText="Применить"
          resetBtnText="Сбросить всё"
          onSubmit={methods.onFilterChange}
          onClose={methods.hideSider}
          fieldsValue={state.filterState}
        />
      </AppSider>
    </>
  );
};
